import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthenticationService } from 'src/app/core/core.module';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

    constructor(public appInfo: AppInformationService, private auth: AuthenticationService, private router: Router) {}

    ngOnInit() {    }

    logout() {
        this.auth.logout();
    }
}
